export default __webpack_public_path__ + "static/media/access-one-true.1c63b55b.svg";